import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

import { ImageUploadModalReturnData } from "../image-upload-interface";

// To use the upload modal component, you will need the following setup in your component:
// const dialogRef = this.dialog.open(LogoUploadModalComponent)
// To retrieve the image from this uploader, use the following code:
// dialogRef.afterClosed().pipe(take(1)).subscribe(response => {
//  do stuff with your response data
// })

@Component({
  selector: "onsip-logo-upload-modal",
  templateUrl: "./logo-upload-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LogoUploadModalComponent {
  logoChange: ImageUploadModalReturnData = {
    doSave: false,
    image: undefined
  };

  constructor(private dialogRef: MatDialogRef<LogoUploadModalComponent>) {}

  dialogResponse($event: ImageUploadModalReturnData): void {
    this.logoChange = $event;
    this.dialogRef.close(this.logoChange);
  }
}
